// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.auth-form_form-card__u4CDx {
    max-width: 400px;
    padding: 50px;
    background-color: var(--color-content);
    color: var(--color-icon-stroke);
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    justify-content: flex-start;
    gap: 20px;
    border-radius: 5px;
    box-shadow: 1px 1px 1px 1px #E6E7EB;
}

.auth-form_tab-content-container__smZ6a {
    width: 100%;
}

.auth-form_tab-button-active__VN\\+eK {
    background-color: #0095FF;
    color: #FFFFFF;
}

.auth-form_form-button__TC0WA {
    border: none;
    color: var(--color-sidebar-typography-active);
    background: var(--color-content-highlight);
    width: 100%;
    height: 34px;
    border-radius: 5px;
    font-size: 14px;
    font-weight: 450;
    margin-top: 20px;
}

.auth-form_forgot-password__9Qi2A {
    width: 100%;
    text-align: left;
    color: var(--color-content-highlight);
    font-size: 12px;
    font-weight: 400;
}

.auth-form_auth-message__urgQO {
    margin-top: 5px;
    width: 100%;
    text-align: left;
    color: var(--color-secondary-typography);
    font-size: 12px;
    font-weight: 400;
}

.auth-form_other-register__OVCkh {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 10px;
    font-size: 14px;
    font-weight: 400;
}

.auth-form_register-ways-container__u\\+jce {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 10px
}

.auth-form_register-icon__fE\\+Wz {
    width: 38px;
    height: 38px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    background-color: var(--color-register-icon);
    border: none;
    outline: none;
}

.auth-form_register-icon__fE\\+Wz:focus {
    outline: none
}`, "",{"version":3,"sources":["webpack://./src/components/auth-form/auth-form.module.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,aAAa;IACb,sCAAsC;IACtC,+BAA+B;IAC/B,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,2BAA2B;IAC3B,SAAS;IACT,kBAAkB;IAClB,mCAAmC;AACvC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,6CAA6C;IAC7C,0CAA0C;IAC1C,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,qCAAqC;IACrC,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,wCAAwC;IACxC,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,2BAA2B;IAC3B,SAAS;IACT,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,2BAA2B;IAC3B;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,4CAA4C;IAC5C,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI;AACJ","sourcesContent":[".form-card {\n    max-width: 400px;\n    padding: 50px;\n    background-color: var(--color-content);\n    color: var(--color-icon-stroke);\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    justify-content: flex-start;\n    gap: 20px;\n    border-radius: 5px;\n    box-shadow: 1px 1px 1px 1px #E6E7EB;\n}\n\n.tab-content-container {\n    width: 100%;\n}\n\n.tab-button-active {\n    background-color: #0095FF;\n    color: #FFFFFF;\n}\n\n.form-button {\n    border: none;\n    color: var(--color-sidebar-typography-active);\n    background: var(--color-content-highlight);\n    width: 100%;\n    height: 34px;\n    border-radius: 5px;\n    font-size: 14px;\n    font-weight: 450;\n    margin-top: 20px;\n}\n\n.forgot-password {\n    width: 100%;\n    text-align: left;\n    color: var(--color-content-highlight);\n    font-size: 12px;\n    font-weight: 400;\n}\n\n.auth-message {\n    margin-top: 5px;\n    width: 100%;\n    text-align: left;\n    color: var(--color-secondary-typography);\n    font-size: 12px;\n    font-weight: 400;\n}\n\n.other-register {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n    gap: 10px;\n    font-size: 14px;\n    font-weight: 400;\n}\n\n.register-ways-container {\n    display: flex;\n    flex-direction: row;\n    align-items: flex-start;\n    justify-content: flex-start;\n    gap: 10px\n}\n\n.register-icon {\n    width: 38px;\n    height: 38px;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    border-radius: 5px;\n    background-color: var(--color-register-icon);\n    border: none;\n    outline: none;\n}\n\n.register-icon:focus {\n    outline: none\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"form-card": `auth-form_form-card__u4CDx`,
	"tab-content-container": `auth-form_tab-content-container__smZ6a`,
	"tab-button-active": `auth-form_tab-button-active__VN+eK`,
	"form-button": `auth-form_form-button__TC0WA`,
	"forgot-password": `auth-form_forgot-password__9Qi2A`,
	"auth-message": `auth-form_auth-message__urgQO`,
	"other-register": `auth-form_other-register__OVCkh`,
	"register-ways-container": `auth-form_register-ways-container__u+jce`,
	"register-icon": `auth-form_register-icon__fE+Wz`
};
export default ___CSS_LOADER_EXPORT___;
